export default __webpack_public_path__ + "static/step5-a24c72d0154be2bf868730b74c0f4105.svg";